<template>
  <HeroVideoBackground :options="data" v-if="heroType === 'video'" />
  <HeroCarousel :options="data" v-else-if="data.showCarousel" />
</template>

<script>
export default {
  name: 'HeroSection',
  props: {
    data: {
      type: Object,
      required: true,
    },
    heroType: {
      type: String,
      required: true,
      default: 'video',
    },
  },
  components: {
    HeroVideoBackground: () => import('@/components/HeroVideoBackground.vue'),
    HeroCarousel: () => import('@/components/HeroCarousel.vue'),
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'
</style>
